export const convertUrl = (code_product) => {
  let url = "";
  if (code_product == 1) {
    url = `${process.env.REACT_APP_BASE_API_URL}product/smartphones`;
  } else if (code_product == 2) {
    url = `${process.env.REACT_APP_BASE_API_URL}product/cars`;
  } else if (code_product == 3) {
    url = `${process.env.REACT_APP_BASE_API_URL}product/bikes`;
  }
  return url;
};
